export default function Logo(): React.ReactElement {
  return (
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Raycast</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6718 26.4315V30.3267L2.33203 20.9869L4.28913 19.0447L11.6718 26.4315ZM15.5668 30.3267H11.6718L21.0114 39.6663L22.9601 37.7199L15.5668 30.3267ZM37.7189 22.944L39.6654 20.9954L21.0029 2.33301L19.0565 4.28163L26.4306 11.6642H21.973L16.8255 6.52101L14.877 8.46748L18.0822 11.6727H15.8513V26.1556H30.3341V23.9162L33.5394 27.1214L35.488 25.175L30.3341 20.0211V15.5636L37.7189 22.944ZM12.646 10.6899L10.6996 12.6385L12.7883 14.7272L14.7347 12.7786L12.646 10.6899ZM29.2198 27.2636L27.2797 29.2102L29.3683 31.2988L31.3148 29.3502L29.2198 27.2636ZM8.4686 14.8694L6.52004 16.818L11.6718 21.9697V18.0725L8.4686 14.8694ZM23.9259 30.3267H20.0286L25.1804 35.4783L27.1289 33.5298L23.9259 30.3267Z"
        fill="#FF6363"
      />
    </svg>
  )
}
